import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import './PageRaceTV.css';

function PageRaceTV() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="racetv-page">
        <header className="racetv-header">
          <button className="btn-back" onClick={() => navigate('/top-10-tv')}>
            &#8592; Top 10 TV
          </button>
          <div className="racetv-title-block">
            <h1 className="racetv-title">Top 10 Canales de TV — Race</h1>
            <p className="racetv-subtitle">Inversión Publicitaria Últimos 12 Meses &middot; Honduras</p>
          </div>
        </header>

        <div className="racetv-video-wrap">
          <video
            className="racetv-video"
            controls
            autoPlay
            playsInline
          >
            <source
              src="https://presentation-hn-2025-q4.publisearch.net/race_chart_canales_top10.mp4"
              type="video/mp4"
            />
            Tu navegador no soporta video HTML5.
          </video>
        </div>
      </div>
    </PageBackground>
  );
}

export default PageRaceTV;
